import React from 'react';
import { useTranslation } from 'react-i18next';
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined';

import scss from './UsedMediaEmptyDisclaimer.module.scss';

function UsedMediaEmptyDisclaimer() {
  const { t } = useTranslation('story');

  return (
    <div className={scss.wrapper}>
      <HistoryOutlinedIcon className={scss.icon} />
      <span className={scss.title}>{t('noUsedMedia')}</span>
      <span className={scss.description}>{t('emptyUsedMediaDescription')}</span>
    </div>
  );
}

export default UsedMediaEmptyDisclaimer;
